import {combineReducers} from 'redux';

import navigation from './navigation'
import auth from './auth';
import uploadSettings from './upload';
import mainListSettings from './main-list';
import detailListSettings from './detail-list';
import consigneeListSettings from './consignee-list';
import consigneeListSettingsNew from './consignee-list-new';
import receiptListSettings from './receipt-list';
import arrivalListSettings from './arrival-list';
import deleteListSettings from './delete-list';
import uploadReceiptSettings from './upload-receipt';
import uploadReceiptNewSettings from './upload-receipt-new';
import decodeProcessListSettings from './decode-process-list';
import emptyPdfSettings from './empty-pdf';
import masterAddUserSettings from './master/add-user';
import masterUsersSettings from './master/users';
import masterNayoseSettings from './master/nayose';
import masterSecomSignatureSettings from './master/secom-signature';
import masterReceiptsReferencesSettings from './master/receipts-references';
import masterJigyoushaSettings from './master/jigyousha';
import masterKeiyakuKigyouSettings from './master/keiyaku-kigyou';
import masterAsnCorporateSettings from "./master/asn-corporate-management";
import masterHasonhoukokuKbnSettings from './master/hasonhoukoku-kbn';
import documentsSettings from './documents';
import informationSettings from './information';
import faqSettings from './faq';
import statisticsSettings from './statistics';
import statisticsListSettings from './statistics-list';
import shipmentSettings from './shipment';
import shipmentDetailSettings from './shipment-detail';
import mappingSettings from './mapping'
import entryListSettings from './entry-list';
import entryDetailSettings from './entry-detail';
import masterTrHenkanSettings from './master/tr-henkan';
import masterAsnHenkanSettings from './master/asncode-henkan';
import deliveryStatusListSettings from './delivery-status-list';
import deliveryStatusDetailSettings from './delivery-status-detail';

import componentsEditableTableState from './components/editable-table';


const rootReducer = combineReducers({
	navigation,
	auth,
	uploadSettings,
	mainListSettings,
	detailListSettings,
	consigneeListSettings,
	consigneeListSettingsNew,
	receiptListSettings,
	arrivalListSettings,
	deleteListSettings,
	uploadReceiptSettings,
	uploadReceiptNewSettings,
	decodeProcessListSettings,
	emptyPdfSettings,
	masterAddUserSettings,
	masterUsersSettings,
	masterJigyoushaSettings,
	masterKeiyakuKigyouSettings,
	masterNayoseSettings,
	masterSecomSignatureSettings,
	masterHasonhoukokuKbnSettings,
	masterReceiptsReferencesSettings,
	masterAsnHenkanSettings,
	masterAsnCorporateSettings,
	documentsSettings,
	informationSettings,
	faqSettings,
	statisticsSettings,
	statisticsListSettings,
	shipmentSettings,
	shipmentDetailSettings,
	mappingSettings,
	componentsEditableTableState,
	entryListSettings,
	entryDetailSettings,
	masterTrHenkanSettings,
	deliveryStatusListSettings,
	deliveryStatusDetailSettings
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js